import { GetterTree } from 'vuex'
import { State } from './state'
import { CurrentUser } from "@/pitprojekt/models/CurrentUser";
import { EventBus } from "@/pitprojekt/event-bus";
import { Product } from "@/pitprojekt/models/Product";
import _ from 'lodash'

export function currentUser (state: State): CurrentUser {
    return state.currentUser
}

export function selectedProducts (state: State): Array<number> {
    return state.selectedProducts
}

export function selectedProduct (state: State): number {
    return state.selectedProduct
}

export function selectedProductObject (state: State): Product|undefined {
    return _.find(state.currentUser.products, {'id': state.selectedProduct});
}

export function multipleProducts (state: State): boolean {
    return !state.onlyOneProductAvailable;
}

export function gettingSettings (state: State): boolean {
    return state.gettingSettings
}

export function settingsComplete (state: State): boolean {
    let settingsComplete: boolean = (state.currentUser !== null);

    if (settingsComplete)
        EventBus.$emit('hideFullScreenLoaderEvent');

    return settingsComplete;
}

export function dateFrom (state: State): string {
    return state.dateFrom;
}

export function dateTo (state: State): string {
    return state.dateTo;
}

export function filterProductsToPitOnly (state: State):boolean {
    return state.filterProductsToPitOnly;
}

export function currentUserProducts (state: State): Array<Product> {
    return state.currentUser.products;
}

export function currentUserProductsPitOnly (state: State): Array<Product> {
    return _.filter(state.currentUser.products, { 'rodzaj': 'pit'});
}

export function lastYear (state: State): boolean {
    return state.lastYear;
}


export default <GetterTree<State, any>> {
    currentUser,
    gettingSettings,
    settingsComplete,
    dateFrom,
    dateTo,
    currentUserProducts,
    selectedProducts,
    selectedProduct,
    multipleProducts,
    selectedProductObject,
    filterProductsToPitOnly,
    currentUserProductsPitOnly,
    lastYear
}
